@if (loading$ | async) {
<div class="backdrop">
  <mat-progress-spinner
    mode="indeterminate"
    class="progress-bar slc-progress-brand"
  ></mat-progress-spinner>
</div>
}
